import React from 'react';
import ReactDOM from 'react-dom/client';

import { ConfigProvider, App as AntApp } from 'antd';
import './index.css';
import App from './App';
import { customThemes } from '../src/themes/themeConfig';
import { Provider as ReduxProvider } from 'react-redux';
import { store, persistor } from './redux/store';

import { PersistGate } from 'redux-persist/integration/react';

// Set up root
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const themeStyles = customThemes.light;
// Render the app
root.render(
  <ConfigProvider
      theme={{
        token: {
          colorText: themeStyles.contentText,
          colorBgContainer: themeStyles.contentBg,
          colorPrimary: themeStyles.colorPrimary,
          // You can override any token
        },
      }}
    >
    <AntApp>
      <React.StrictMode>
        <ReduxProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>

            <App />
          </PersistGate>
        </ReduxProvider>
      </React.StrictMode>
    </AntApp>
  </ConfigProvider>
);

// Service Worker registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}